import { PaginationItemType } from "./pagination-item-type.enum";

export class PaginationItemModel {
    public constructor(
        public pageNumber: number,
        public displayLabel: string,
        public ariaLabel: string,
        public buttonType: PaginationItemType,
        public buttonStyle: string,
        public navigationUrl: string,
        public isCurrentPage: boolean
    ) {
    }

    public hasUrl(): boolean {
        return this.navigationUrl.length > 0;
    }
}
